//Get Reducer Call--->
export const getAllotmentRequest = (page: number, size: number, search: string, order_by: string) => ({
    type: 'GET_ALLOTMENT_REQUEST',
    payload: { page, size, search, order_by },
});

export const getAllotmentSuccess = (data: any) => ({
    type: 'GET_ALLOTMENT_SUCCESS',
    payload: { data },
});

export const getAllotmentFailure = (errorMessage: string) => ({
    type: 'GET_ALLOTMENT_FAILURE',
    errorMessage: { errorMessage },
});

export const resetGetAllotment = () => ({
    type: 'RESET_GET_ALLOTMENT',
});

//Create Reducer Call--->
export const createAllotmentRequest = (data: any) => ({
    type: 'CREATE_ALLOTMENT_REQUEST',
    payload: data,
});

export const createAllotmentSuccess = (data: any) => ({
    type: 'CREATE_ALLOTMENT_SUCCESS',
    payload: { data },
});

export const createAllotmentFailure = (errorMessage: string) => ({
    type: 'CREATE_ALLOTMENT_FAILURE',
    errorMessage: { errorMessage },
});

export const resetCreateAllotment = () => ({
    type: 'RESET_CREATE_ALLOTMENT',
});

//Update Reducer Call--->
export const updateAllotmentRequest = (data: any, id: string) => ({
    type: 'UPDATE_ALLOTMENT_REQUEST',
    payload: { data, id },
});

export const updateAllotmentSuccess = (data: any) => ({
    type: 'UPDATE_ALLOTMENT_SUCCESS',
    payload: { data },
});

export const updateAllotmentFailure = (errorMessage: string) => ({
    type: 'UPDATE_ALLOTMENT_FAILURE',
    errorMessage: { errorMessage },
});

export const resetUpdateAllotment = () => ({
    type: 'RESET_UPDATE_ALLOTMENT',
});
//Delete Reducer Call--->
export const deleteAllotmentRequest = (id: string) => ({
    type: 'DELETE_ALLOTMENT_REQUEST',
    payload: { id },
});

export const deleteAllotmentSuccess = (data: any) => ({
    type: 'DELETE_ALLOTMENT_SUCCESS',
    payload: { data },
});

export const deleteAllotmentFailure = (errorMessage: string) => ({
    type: 'DELETE_ALLOTMENT_FAILURE',
    errorMessage: { errorMessage },
});

export const resetDeleteAllotment = () => ({
    type: 'RESET_DELETE_ALLOTMENT',
});
